import { Component, Input } from "@angular/core";

import { DeviceType } from "../../sessions";

@Component({
	selector: "sdp-generic-device-type-column",
	templateUrl: "./deviceType-column.component.html"
})
export class DeviceTypeColumnComponent {

	@Input()
	public cssClass!: string | undefined;

	@Input()
	public set deviceType(backingType: DeviceType.BackingType) {
		this.type = DeviceType.Type[backingType] || undefined;
	}

	public type: string | undefined;

	public readonly errorIcon = { type: "material", name: "error", cssClass: "sdp-generic-icon-error" };

}
